import { useContext } from 'react';

import { OrgUnitLocalStateContext } from './OrgUnitContextProviderLocal';

import OrgUnitData from './OrgUnitData';

const useOrgUnitData = () => {
  const [orgUnitState, setOrgUnitState] = useContext(OrgUnitLocalStateContext);

  const getOrgUnitByCurrentPerson = (reportInfoId) => OrgUnitData.getOrgUnitByCurrentPersonData(reportInfoId, orgUnitState, setOrgUnitState);

  return {
    orgUnitState,
    getOrgUnitByCurrentPerson
  };
};

export default useOrgUnitData;